import { MinutePlot } from './MinutePlot';
import { PlotContainer } from './PlotContainer';
import { SingleLeadPlot } from './SingleLeadPlot';
import { useNoiseListener } from '../../ecg/hooks/useNoiseListener';

export const ZoomNoisePlot = () => {
  useNoiseListener();
  return (
    <PlotContainer>
      <SingleLeadPlot />
      <MinutePlot />
    </PlotContainer>
  );
};
